(() => {
  if (window.dsCardColorsReady) return;
  window.dsCardColorsReady = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.ds-card__color-button');
    if (!button) return;

    event.preventDefault();
    const card = button.closest('.card-wrapper');
    const group = button.closest('.ds-card__colors');
    if (!card || !group || button.getAttribute('aria-pressed') === 'true') return;

    const images = card.querySelectorAll('.ds-card__media > img');
    if (!images.length) return;

    images[0].srcset = button.dataset.backSrcset;
    images[0].src = button.dataset.backSrc;
    images[0].alt = button.dataset.backAlt;
    const hasFront = Boolean(images[1] && button.dataset.frontSrc);
    if (hasFront) {
      images[1].srcset = button.dataset.frontSrcset;
      images[1].src = button.dataset.frontSrc;
      images[1].alt = button.dataset.frontAlt;
    } else {
      const viewToggle = card.querySelector('.ds-card__view-toggle');
      if (viewToggle) viewToggle.checked = false;
    }
    card.classList.toggle('ds-card--front-unavailable', !hasFront);

    group.querySelectorAll('.ds-card__color-button').forEach((option) => {
      option.setAttribute('aria-pressed', String(option === button));
    });
    if (button.dataset.priceText) {
      const price = card.querySelector('.card-information .price');
      const regularPrice = price?.querySelector('.price__regular > .price-item--regular');
      const salePrice = price?.querySelector('.price__sale .price-item--last');
      if (regularPrice) regularPrice.textContent = button.dataset.priceText;
      if (salePrice) salePrice.textContent = button.dataset.priceText;
    }
    card.querySelectorAll('a.full-unstyled-link[href]').forEach((link) => {
      link.href = button.dataset.variantUrl;
    });
  });
})();
